import useSceneWalkthrough from "features/onboarding/guided/walkthrough/useSceneWalkthrough";
import { LanguageNameSpaces } from "@shared/types";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";
import WalkthroughPanel from "features/onboarding/guided/walkthrough/WalkthroughPanel";

const DcaDemo = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.ONBOARDING);
  const walk = useSceneWalkthrough("dca", 4);
  const { stage, chartRef, advance, playing, togglePlayback } = walk;
  return (
    <WalkthroughPanel
      intent="dca"
      stage={stage}
      total={4}
      label={t(`revision.dca_event${stage as 0 | 1 | 2 | 3 | 4}`)}
      caption={
        stage === 0
          ? t("intent.waiting")
          : walk.steps
          ? walk.steps[stage - 1].description!
          : t(`revision.dca_event${stage as 1 | 2 | 3 | 4}`)
      }
      playing={playing}
      {...walk.panel}
      togglePlayback={togglePlayback}
      advance={advance}
      actionLabel={
        stage === 4
          ? t("intent.replay")
          : stage === 3
          ? t("revision.dca_rebound")
          : t("revision.dca_fill", { entry: stage + 1 })
      }
      chartRef={chartRef}
    />
  );
};

export default DcaDemo;
